import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { BranchListView } from './views/BranchListView';

export const branchManagementRoutes: RouteObject[] = [
    {
        path: '/admin/branches',
        element: <BranchListView />,
        errorElement: <ErrorBoundary />,
    },
];
